/**
 * Logica di paginazione.
 *
 * L'endpoint `newstories` restituisce ~500 ID in un colpo solo: caricarne il
 * dettaglio tutti insieme significherebbe 500 richieste HTTP e un'interfaccia
 * bloccata. Queste funzioni pure calcolano quale "fetta" di ID richiedere,
 * senza toccare né la rete né il DOM — sono quindi testabili in isolamento.
 */

/**
 * Restituisce gli ID della pagina richiesta.
 *
 * @param {number[]} ids elenco completo degli ID
 * @param {number} page indice della pagina, 0-based
 * @param {number} [pageSize=10]
 * @returns {number[]} fetta di ID (array vuoto se la pagina è oltre la fine)
 */
export function getPageIds(ids, page, pageSize = 10) {
  if (!Array.isArray(ids) || pageSize <= 0 || page < 0) return [];
  const start = page * pageSize;
  return ids.slice(start, start + pageSize);
}

/**
 * Numero totale di pagine disponibili.
 *
 * @param {number} totalItems
 * @param {number} [pageSize=10]
 * @returns {number}
 */
export function getTotalPages(totalItems, pageSize = 10) {
  if (!Number.isFinite(totalItems) || totalItems <= 0 || pageSize <= 0) return 0;
  return Math.ceil(totalItems / pageSize);
}

/**
 * Indica se esiste almeno un'altra pagina da caricare.
 *
 * @param {number[]} ids elenco completo degli ID
 * @param {number} loadedPages pagine già caricate
 * @param {number} [pageSize=10]
 * @returns {boolean}
 */
export function hasNextPage(ids, loadedPages, pageSize = 10) {
  if (!Array.isArray(ids)) return false;
  return loadedPages * pageSize < ids.length;
}

/**
 * Quante news restano da caricare rispetto al totale disponibile.
 *
 * @param {number} totalIds
 * @param {number} loadedCount
 * @returns {number}
 */
export function getRemainingCount(totalIds, loadedCount) {
  const remaining = (Number(totalIds) || 0) - (Number(loadedCount) || 0);
  return Math.max(0, remaining);
}
